<template>
  <CommonPages id="download" :class="['download']" :metaTitle="getMetaTitle()"
    :metaDescription="getMetaDescription()" :metaKeywords="getMetaKeyword()">
    <div class="download-apk-mobile-page">
      <div class="download-apk-mobile-page__content">

        <div class="download-apk-mobile-page__content-row">
          <!-- 上半部分 - 信息展示 -->
          <div class="download-apk-mobile-page__info-wrapper">
            <h2 class="download-apk-mobile-page__title">
              Film Plus -Free Movie &amp; TV Show Online
            </h2>
            <div class="download-apk-mobile-page__logo">
              <img src="@/assets/ads/logo.png" alt="Film Plus Logo"
                class="download-apk-mobile-page__logo-img" />
            </div>
            <a class="download-apk-mobile-page__download-btn" :href="downloadLink" :target="downloadTarget" rel="noopener noreferrer">
              <div class="download-apk-mobile-page__download-btn-text">
                Download The App
              </div>
              <div class="download-apk-mobile-page__download-btn-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"
                  fill="none">
                  <path
                    d="M0.989728 15.0104L15.0106 0.989545M15.0106 0.989545L7.64157 0.935757M15.0106 0.989545L15.0644 8.35857"
                    stroke="black" stroke-width="1.25" />
                </svg>
              </div>
            </a>
            <div class="download-apk-mobile-page__users">
              <div class="download-apk-mobile-page__users-avatar">
                <img src="@/assets/ads/face.svg" alt="User 1"
                  class="download-apk-mobile-page__users-img" />
                <img src="@/assets/ads/face.svg" alt="User 2"
                  class="download-apk-mobile-page__users-img" />
                <img src="@/assets/ads/face.svg" alt="User 3"
                  class="download-apk-mobile-page__users-img" />
                <img src="@/assets/ads/face.svg" alt="User 4"
                  class="download-apk-mobile-page__users-img" />
              </div>
              <div class="download-apk-mobile-page__users-text">
                100 thousand+<br />
                Our users worldwide
              </div>
            </div>
          </div>

          <!-- 手机图片展示区域 -->
          <div class="download-apk-mobile-page__pic">
            <img src="@/assets/ads/hand.png" alt="Mobile App"
              class="download-apk-mobile-page__pic-img" />
          </div>
        </div>

        <!-- 下载区域 -->
        <div class="download-apk-mobile-page__download-section">
          <div class="download-apk-mobile-page__download-title">
            Download App
          </div>
          <a class="download-apk-mobile-page__download-button" :href="downloadLink" :target="downloadTarget" rel="noopener noreferrer">
            <svg xmlns="http://www.w3.org/2000/svg" class="download-apk-mobile-page__download-icon"
              viewBox="0 0 22 24" fill="none">
              <path
                d="M1.375 21.6H20.625C21.0146 21.6 21.3411 21.715 21.6047 21.945C21.8682 22.175 22 22.46 22 22.8C22 23.14 21.8682 23.425 21.6047 23.655C21.3411 23.885 21.0146 24 20.625 24H1.375C0.985417 24 0.658854 23.885 0.395312 23.655C0.131771 23.425 0 23.14 0 22.8C0 22.46 0.131771 22.175 0.395312 21.945C0.658854 21.715 0.985417 21.6 1.375 21.6ZM11 18.45C10.7937 18.45 10.5932 18.41 10.3984 18.33C10.2036 18.25 10.0375 18.13 9.9 17.97L3.09375 10.35C2.75 9.95 2.70417 9.525 2.95625 9.075C3.20833 8.625 3.62083 8.4 4.19375 8.4H6.875V1.2C6.875 0.86 7.00677 0.575 7.27031 0.345C7.53385 0.115 7.86042 0 8.25 0H13.75C14.1396 0 14.4661 0.115 14.7297 0.345C14.9932 0.575 15.125 0.86 15.125 1.2V8.4H17.8062C18.3792 8.4 18.7917 8.625 19.0438 9.075C19.2958 9.525 19.25 9.95 18.9062 10.35L12.1 17.97C11.9625 18.13 11.7964 18.25 11.6016 18.33C11.4068 18.41 11.2063 18.45 11 18.45Z"
                fill="white" />
            </svg>
            <span>Download</span>
          </a>

          <div class="download-apk-mobile-page__features ">
            <div class="download-apk-mobile-page__feature Safety">
            </div>
            <div class="download-apk-mobile-page__feature Fast">
            </div>
            <div class="download-apk-mobile-page__feature Ads">
            </div>
          </div>

          <div class="download-apk-mobile-page__qr-container">
            <img src="@/assets/ads/downloadqr.png" alt="QR Code"
              class="download-apk-mobile-page__qr-img" />
          </div>
        </div>

        <!-- 社交媒体链接 -->
        <div class="download-apk-mobile-page__social-links">
          <a href="#"
            class="download-apk-mobile-page__social-link download-apk-mobile-page__social-link--telegram">
            <img src="@/assets/ads/telegram.png" alt="Telegram"
              class="download-apk-mobile-page__social-icon" />
            <div class="download-apk-mobile-page__social-text">
              Join the Telegram Group
            </div>
          </a>
          <a href="#"
            class="download-apk-mobile-page__social-link download-apk-mobile-page__social-link--x">
            <img src="@/assets/ads/x.png" alt="X" class="download-apk-mobile-page__social-icon" />
            <div class="download-apk-mobile-page__social-text">
              Follow Us on X
            </div>
          </a>
          <a href="#"
            class="download-apk-mobile-page__social-link download-apk-mobile-page__social-link--whatsapp">
            <img src="@/assets/ads/whats.png" alt="WhatsApp"
              class="download-apk-mobile-page__social-icon" />
            <div class="download-apk-mobile-page__social-text">
              Follow Us on WhatsApp
            </div>
          </a>
          <a href="#"
            class="download-apk-mobile-page__social-link download-apk-mobile-page__social-link--instagram">
            <img src="@/assets/ads/ins.png" alt="Instagram"
              class="download-apk-mobile-page__social-icon" />
            <div class="download-apk-mobile-page__social-text">
              Follow Us on Instagram
            </div>
          </a>
          <a href="#"
            class="download-apk-mobile-page__social-link download-apk-mobile-page__social-link--facebook">
            <img src="@/assets/ads/face.png" alt="Facebook"
              class="download-apk-mobile-page__social-icon" />
            <div class="download-apk-mobile-page__social-text">
              Follow Us on Facebook
            </div>
          </a>
        </div>
      </div>
    </div>
  </CommonPages>
</template>

<script>
import common from '@/mixin/common.js'
import { mapGetters } from 'vuex';
import CommonPages from '@/pages/components/page_common.vue'
import '@/css/common.scss';
import '@/css/home.scss';

export default {
  name: 'DownloadApkMobilePage',
  components: {
    CommonPages,
  },
  mixins: [common],
  computed: {
    ...mapGetters([
      'deviceType',
      'domainConfig',
    ]),
    downloadLink() {
      return this.domainConfig?.downloadUrl || '/movie-download/'
    },
    downloadTarget() {
      return this.domainConfig?.downloadUrl ? '_blank' : '_self'
    },
  },
  methods: {
    getMetaTitle () {
      if (!this.domainConfig || !this.domainConfig.IAmURL) {
        return `Download ${this.domainConfig?.siteName || 'Our site'} APK Safe & Fast – Hollywood, Bollywood & More`;
      }

      if (this.domainConfig.IAmURL.includes('movies123plus')) {
        return `Download 123Movies APK Safe & Fast – Hollywood, Bollywood & More`;
      }

      if (this.domainConfig.IAmURL.includes('movierulezhub')) {
        return "MovieRulz APK Free Download – No Ads, Unlimited Movie Streaming";
      }

      if (this.domainConfig.IAmURL.includes('hdxhub4u')) {
        return "HDHub4u APK Download for Android - Latest Version 2025";
      }

      if (this.domainConfig.IAmURL.includes('filmzillaxtra')) {
        return "Download Filmyzilla APK Latest Version (2025) for Free Streaming";
      }

      if (this.domainConfig.IAmURL.includes('f-moviezhub')) {
        return "Fmovies APK Free Download -Movie Downloader Free (2025 Update)";
      }

      return `Download ${this.domainConfig?.siteName || 'Our site'} APK Safe & Fast – Hollywood, Bollywood & More`;
    },
    getMetaKeyword () {
      if (!this.domainConfig || !this.domainConfig.IAmURL) {
        return `Download ${this.domainConfig?.siteName || 'Our site'} APK`;
      }

      if (this.domainConfig.IAmURL.includes('movies123plus')) {
        return `Download 123Movies APK`;
      }

      if (this.domainConfig.IAmURL.includes('movierulezhub')) {
        return "Download MovieRulz App";
      }

      if (this.domainConfig.IAmURL.includes('hdxhub4u')) {
        return "Download HDHub4u APK";
      }

      if (this.domainConfig.IAmURL.includes('filmzillaxtra')) {
        return "Filmyzilla APK Download";
      }

      if (this.domainConfig.IAmURL.includes('f-moviezhub')) {
        return "Fmovies APK Free Download";
      }

      return `Download ${this.domainConfig?.siteName || 'Our site'} APK`;
    },
    getMetaDescription () {
      if (!this.domainConfig || !this.domainConfig.IAmURL) {
        return `Download the latest version of ${this.domainConfig?.siteName || 'Our site'} APK and enjoy unlimited access to free HD movies and TV shows on your Android device. Stream or Download movies hd APK Now!`;
      }

      return `Download the latest version of ${this.domainConfig?.siteName || 'Our site'} APK and enjoy unlimited access to free HD movies and TV shows on your Android device. Stream or Download movies hd APK Now!`;
    }
  },
};
</script>

<style lang="scss">
@import '@/css/variables.scss';

.download-apk-mobile-page {
	&__content {
		display: flex;
		flex-direction: column;
		width: 100%;
		padding: 0 rem(16);
	}

	&__content-row {
		background: url('~@/assets/mdbg.png') no-repeat center center;
		background-size: cover;
	}

	// 上半部分 - 信息展示
	&__info-wrapper {
		padding: rem(36) rem(24) rem(36) rem(24);
		display: flex;
		flex-direction: column;
		gap: rem(24);
		align-items: flex-start;
		justify-content: flex-start;
		position: relative;
	}

	&__title {
		color: #ffffff;
		text-align: left;
		font-family: 'Inter-Black', sans-serif;
		font-size: rem(44);
		line-height: 100%;
		letter-spacing: 0.01em;
		font-weight: 900;
		position: relative;
		align-self: stretch;
	}

	&__logo {
		width: rem(120);
		height: rem(120);
		position: relative;
		overflow: hidden;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	// &__logo-img {
	// 	height: auto;
	// 	position: absolute;
	// 	left: 50%;
	// 	top: 50%;
	// 	transform: translate(-50%, -50%);
	// }

	&__download-btn {
		border-radius: rem(50);
		border-style: solid;
		border-color: #ffffff;
		border-width: 1px;
		padding: rem(8) rem(8) rem(8) rem(20);
		display: flex;
		flex-direction: row;
		gap: rem(12);
		align-items: center;
		justify-content: flex-start;
		flex-shrink: 0;
		position: relative;
		text-decoration: none;
		color: inherit;
	}

	&__download-btn-text {
		color: #ffffff;
		text-align: left;
		font-family: 'Inter-SemiBold', sans-serif;
		font-size: rem(16);
		line-height: 150%;
		letter-spacing: 0.01em;
		font-weight: 600;
		text-transform: uppercase;
		position: relative;
	}

	&__download-btn-icon {
		background: #ffffff;
		border-radius: rem(50);
		display: flex;
		flex-direction: row;
		gap: rem(10);
		align-items: center;
		justify-content: center;
		flex-shrink: 0;
		width: rem(36);
		height: rem(36);
		position: relative;
	}

	&__users {
		display: flex;
		flex-direction: row;
		gap: rem(16);
		align-items: flex-start;
		justify-content: flex-start;
		flex-shrink: 0;
		position: relative;
	}

	&__users-avatar {
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: flex-start;
		flex-shrink: 0;
		position: relative;
	}

	&__users-img {
		background: linear-gradient(to left, #d9d9d9, #d9d9d9);
		border-radius: 50%;
		border-style: solid;
		border-color: #ffffff;
		border-width: 2.5px;
		flex-shrink: 0;
		width: rem(36);
		height: rem(36);
		position: relative;
		box-shadow: 0px 10px 15px 0px rgba(30, 215, 96, 0.08);
		object-fit: cover;

		&:not(:first-child) {
			margin: 0 0 0 rem(-8);
		}
	}

	&__users-text {
		color: #ffffff;
		text-align: left;
		font-family: 'OpenSans-Regular', sans-serif;
		font-size: rem(16);
		line-height: 125%;
		font-weight: 400;
		position: relative;
	}

	// 手机图片区域
	&__pic {
		width: 100%;
		height: rem(480);
		position: relative;
	}

	&__pic-img {
		width: 115%;
		height: 100%;
		object-fit: contain;
	}

	// 下载区域
	&__download-section {
		background: var(--p-3, #121212);
		border-radius: rem(36);
		padding: rem(36) 0 0;
		display: flex;
		flex-direction: column;
		gap: rem(36);
		align-items: center;
		justify-content: flex-start;
		width: 100%;
		margin-bottom: rem(16);
		margin-top: rem(16);
	}

	&__download-title {
		background: var(--linear, linear-gradient(90deg, rgba(177, 50, 251, 1) 0%, rgba(255, 175, 0, 1) 50%, rgba(254, 50, 75, 1) 100%));
		background-clip: text;
		-webkit-background-clip: text;
		-webkit-text-fill-color: transparent;
		text-align: center;
		font-family: 'Inter-ExtraBold', sans-serif;
		font-size: rem(48);
		line-height: rem(48);
		letter-spacing: 0.01em;
		font-weight: 800;
		align-self: stretch;
	}

	&__download-button {
		background: linear-gradient(180deg, rgba(177, 50, 251, 1) 0%, rgba(254, 50, 75, 1) 100%);
		border-radius: rem(100);
		border-style: solid;
		border-color: rgba(255, 255, 255, 0.1);
		border-width: 1px;
		padding: rem(18) rem(14);
		display: flex;
		flex-direction: row;
		gap: rem(24);
		align-items: center;
		justify-content: center;
		width: rem(240);
		height: rem(52);
		position: relative;
		cursor: pointer;
		text-decoration: none;
		color: inherit;

		span {
			color: #ffffff;
			text-align: left;
			font-family: 'Inter-Bold', sans-serif;
			font-size: rem(20);
			line-height: rem(20);
			font-weight: 700;
			position: relative;
		}
	}

	&__download-icon {
		flex-shrink: 0;
		width: rem(22);
		height: rem(24);
		position: relative;
		aspect-ratio: 22/24;
	}

	&__features {
		padding: 0 rem(16);
		display: flex;
		flex-direction: row;
		align-items: flex-start;
		justify-content: space-between;
		width: 100%;
	}

	&__feature {
		// background: var(--linear, linear-gradient(180deg, rgba(13, 12, 15, 1) 0%, rgba(42, 40, 46, 1) 100%));
		// border-radius: rem(24);
		// border-width: 2px;
		// border-style: solid;
		// border-image: var(--linear, linear-gradient(90deg, rgba(177, 50, 251, 1) 0%, rgba(255, 175, 0, 1) 50%, rgba(254, 50, 75, 1) 100%));
		// border-image-slice: 1;
		// display: flex;
		// flex-direction: column;
		// gap: rem(4);
		// align-items: center;
		// justify-content: center;
		width: rem(100);
		height: rem(100);
		&.Safety {
			background: url('~@/assets/safe.png') no-repeat center center;
			background-size: cover;
		}
		&.Fast {
			background: url('~@/assets/fast.png') no-repeat center center;
			background-size: cover;
		}
		&.Ads {
			background: url('~@/assets/ads.png') no-repeat center center;
			background-size: cover;
		}
	}

	&__feature-icon {
		flex-shrink: 0;
		width: rem(60);
		height: rem(60);
		position: relative;
		aspect-ratio: 1;
	}

	&__feature-text {
		color: #ffffff;
		text-align: left;
		font-family: 'Inter-Black', sans-serif;
		font-size: rem(16);
		line-height: rem(16);
		font-weight: 900;
		text-transform: uppercase;
		position: relative;
	}

	&__qr-container {
		// border-radius: rem(28);
		// width: rem(200);
		// height: rem(200);
		width: rem(281);
		height: rem(354);
		position: relative;
		background: url('~@/assets/phone.png') no-repeat center center;
		background-size: cover;
	}

	&__qr-img {
		width: rem(200);
		height: rem(200);
		position: absolute;
		top: rem(100);
		left: 50%;
		transform: translateX(-50%);
	}

	// 社交媒体链接
	&__social-links {
		padding: 0 rem(16) rem(44) rem(16);
		display: flex;
		flex-direction: column;
		gap: rem(20);
		align-items: flex-start;
		justify-content: flex-start;
		flex-shrink: 0;
		position: relative;
	}

	&__social-link {
		background: #000000;
		border-radius: rem(24);
		border-style: solid;
		border-color: rgba(255, 255, 255, 0.1);
		border-width: 2px;
		padding: rem(14) rem(20);
		display: flex;
		flex-direction: row;
		gap: rem(16);
		align-items: center;
		justify-content: flex-start;
		align-self: stretch;
		flex-shrink: 0;
		position: relative;
		text-decoration: none;

		&--telegram {
			background: #039be5;
		}

		&--x {
			background: #000000;
		}

		&--whatsapp {
			background: #29a71a;
		}

		&--instagram {
			border: none;
			background: var(--linear, linear-gradient(45deg, rgba(255, 213, 33, 1) 0%, rgba(255, 208, 32, 1) 5.51%, rgba(254, 192, 30, 1) 12.41%, rgba(252, 167, 27, 1) 20.04%, rgba(250, 131, 22, 1) 28.21%, rgba(248, 85, 16, 1) 36.81%, rgba(245, 30, 9, 1) 45.63%, rgba(243, 0, 5, 1) 50%, rgba(242, 0, 7, 1) 50.35%, rgba(225, 0, 59, 1) 59.66%, rgba(211, 0, 103, 1) 68.79%, rgba(199, 0, 136, 1) 77.57%, rgba(191, 0, 160, 1) 85.89%, rgba(187, 0, 175, 1) 93.57%, rgba(185, 0, 180, 1) 100%));
		}

		&--facebook {
			background: #1877f2;
		}
	}

	&__social-icon {
		flex-shrink: 0;
		width: rem(44);
		height: rem(44);
		position: relative;
		aspect-ratio: 1;
	}

	&__social-text {
		color: #ffffff;
		text-align: left;
		font-family: 'Inter-Black', sans-serif;
		font-size: rem(16);
		line-height: rem(20);
		font-weight: 900;
		position: relative;
		flex: 1;
	}
}
</style> 